import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, Input, OnDestroy } from '@angular/core';

import { LoadingService } from './../../loading';

import { FileRef } from '@shared/data';

@Component({
  selector: 'edit-file',
  styles: [require('./edit-file.component.scss')],
  template: require('./edit-file.component.html')
})
export class EditFileComponent implements OnInit, OnDestroy {
  @Input()
  public file: FileRef;

  public error: Parse.Error;
  public isSaving: boolean;

  constructor(private activeModal: NgbActiveModal) {

  }

  public ngOnInit() {

  }

  public ngOnDestroy() {
    this.file.revert();
  }

  public onSave() {
    this.isSaving = true;

    this.file.save().then(
      result => {
        this.isSaving = false;
        this.activeModal.close();
      },
      error => {
        this.error = error;
      }
    )
  }

  public onClose() {
    this.activeModal.close()
  }

  public onDismiss() {
    this.activeModal.dismiss('');
  }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/+file-manager/edit-file/edit-file.component.ts